import {
  afterUploadToServer,
  afterRemoveFromServer,
  removeFromServer,
  getExtension,
} from 'utils/_dropzone.js'
import dayjs from 'dayjs'
import tz from 'dayjs/plugin/timezone'
dayjs.extend(tz)
import {loadingWindowVisible, loadingWindowHidden, loadingWindowHandler} from '4-component/loading/_index.js'
import { convertDateManual, convertDateAuto, convertDateObject, convertDateCE } from 'utils/_convert_date.js'
import runGallery from 'utils/_run_gallery.js'


let setErrorText = () => {
  const errorTextBlock = document.querySelector('.loading__error-text')
  if( errorTextBlock ) {
    const errorMessageBlock = document.getElementById('loading_error_file_upload')
    if( errorMessageBlock ) {
      errorTextBlock.innerHTML = errorMessageBlock.innerText
    }
  }
}

/**
 * @param {int|string} orderId
 * @param {string} urlDir
 * @param {string} orderFilesIdsElementId
 * @param {string} variantClass
 */
export default (
  orderId,
  urlDir,
  orderFilesIdsElementId,
  variantClass,
) => {
  let orderFilesIdsElement = document.getElementById(orderFilesIdsElementId)
  let orderFilesIds = JSON.parse(orderFilesIdsElement.value || '[]') || []
  let orderFiles = JSON.parse(orderFilesIdsElement.dataset.mockFiles)
  let uploadUrl = orderFilesIdsElement.dataset.uploadUrl
  let removeUrl = orderFilesIdsElement.dataset.removeUrl
  let urlPrefix = window.location.origin + '/uploads/'+urlDir+'/'
  let urlPreviewPrefix = window.location.origin + '/uploads/preview_'+urlDir+'/'
  let dropzoneElement = document.querySelector('.'+variantClass+' .order-detail__form-dropzone')
  let dropzonePreviewsContainerElement = document.querySelector('.'+variantClass+' .order-detail__form-dropzone .dropzone-previews')
  let dropzoneClickableElement = document.querySelector('.'+variantClass+' .order-detail__form-dropzone .dropzone-clickable')
  let dropzonePreviewTemplate = document.querySelector('.'+variantClass+' .order-detail__form-dropzone .dropzone-template').innerHTML

  let autoProcessQueue = true
  if( variantClass === '--result-files' ) {
    autoProcessQueue = false
  }

  const previewExt = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'];
  const customPreviewExt = ['pdf', 'cdr', 'eps', 'ai'];

  return new Dropzone(dropzoneElement, {
    url: uploadUrl,
    previewsContainer: dropzonePreviewsContainerElement,
    clickable: dropzoneClickableElement,
    previewTemplate: dropzonePreviewTemplate,
    autoProcessQueue: autoProcessQueue,
    autoQueue: true,
    pxfVisibility: '',
    maxFilesize: 50,

    init: function() {

      let myDropzone = this

      /*this.on("success", function(file, response) {
        console.log('dropzone success')
        console.log(file.status)
        console.log(response)

        file.xhr && afterUploadToServer(this, file, orderFilesIdsElement)(file.xhr)
        if( !file.existing ) {
          loadingWindowHidden('process')
          loadingWindowVisible('success')
        }
      });*/

      this.on("error", function(file, response) {
        //console.log('dropzone error')
        /*console.log(file)
        console.log(response)*/
        file.previewElement.remove()
        loadingWindowHidden('process', '#page-ajax')
        loadingWindowVisible('error', '#page-ajax')

        setErrorText()
      });

      /*this.on("accept", function(file, done) {
        console.log('dropzone accept')
        if (file.size > this.options.maxFilesize * 1024 * 1024) {
          return done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
        }
      });*/

      this.on('queuecomplete', function() {
        //console.log('queuecomplete')
        //loadingWindowHidden('process', '#page-ajax')
        //loadingWindowVisible('success', '#page-ajax')
        //runGallery()
      });


      this.on('addedfiles', function(fileList) {
        //console.log('addedfiles')

        let zipExist = false
        if( autoProcessQueue === false ) {
          fileList.forEach((file) => {
            const ext = getExtension(file.name)
            if( (file.status === 'added' || file.status === 'queued') && ext === 'zip' ) {
              const uploadTypeForm = document.querySelector('.upload-type')
              if( uploadTypeForm ) {
                uploadTypeForm.classList.add('visible')
                zipExist = true
                //return false
              }
            }
          })

          if( zipExist === false ) {
            setTimeout(function () {
              return myDropzone.processQueue();
            }, 100);
          }
        }
      });

      this.on('addedfile',
        /**
         * @param {File} file
         */
        function(file) {

          //console.log('dropzone addedfile')

          const ext = getExtension(file.name)

          if( autoProcessQueue === false && file.status === 'added' && ext === 'zip' ) {
            //console.log('+ manual send')
            const uploadTypeForm = document.querySelector('.upload-type')
            if( uploadTypeForm ) {
              //uploadTypeForm.classList.add('visible')
              file.previewElement.remove()
              return false
            }
          }


          file.previewElement.querySelector('.dz-file-extension').innerHTML = ext
          //file.previewElement.querySelector('.dz-file-link').setAttribute('href', file.url);
          const dzDetails = file.previewElement.querySelector('.dz-details')
          if( file.url ) {
            dzDetails.setAttribute('href', file.url)
          }

          dzDetails.setAttribute('download', file.name)


          if( previewExt.indexOf(ext) !== -1 ) {
            //dzDetails.removeAttribute('download')
            dzDetails.removeAttribute('target')
            dzDetails.classList.add('gallery-modal')
          }
          else if( customPreviewExt.indexOf(ext) !== -1 && file.previewUrl ) {
            dzDetails.removeAttribute('target')
            dzDetails.classList.add('gallery-modal')
            dzDetails.setAttribute('data-preview', file.previewUrl)
          }
          else if( customPreviewExt.indexOf(ext) !== -1 && !file.previewUrl ) {
            dzDetails.classList.add('dz-download-link')
          }
          else {
            //dzDetails.setAttribute('download', file.name)
          }

          dzDetails.setAttribute('data-download', file.name)


          const dzDownloadLink = file.previewElement.querySelector('.dz-download-link')
          if( file.url ) {
            dzDownloadLink.setAttribute('href', file.url)
            dzDownloadLink.setAttribute('download', file.name)
          }

          const dzFileLink = file.previewElement.querySelector('.dz-file-link')
          if( dzFileLink ) {
            dzFileLink.addEventListener('click', (event)=>{
              event.preventDefault()
              dzDownloadLink.click()
            })
          }

          let fileDate = '';
          if( file.createdAt ) {

            //fileDate = convertDateManual(file.createdAt)
            fileDate = convertDateCE(file.createdAt)

            /*let d1 = new Date(parseInt(file.createdAt, 10) * 1000);

            let df = dayjs( new Date(parseInt(file.createdAt, 10) * 1000) ).format('YYYY-MM-DDTHH:mm:ss')
            df = df + 'Z';
            console.log('df', df)
            console.log(dayjs.utc(df).local().format('YYYY-MM-DD HH:mm:ss'))

            fileDate = dayjs(new Date(parseInt(file.createdAt, 10) * 1000)).format('YYYY-MM-DD HH:mm:ss')*/
          }
          else {
            //fileDate = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')

            fileDate = dayjs(new Date()).tz("Europe/Vienna").format('YYYY-MM-DD HH:mm:ss')
          }

          if( file.serverFileId ) {
            file.previewElement.querySelector('.dz-file-checkbox').value = file.serverFileId
          }

          file.previewElement.querySelector('.dz-created').innerHTML = fileDate

          //console.log(file);


          if (previewExt.indexOf(ext) === -1) {
            if( customPreviewExt.indexOf(ext) !== -1 && file.previewUrl ) {

              //file.dataURL = file.previewUrl
              //myDropzone.createThumbnailFromUrl(file);

              //myDropzone.emit("thumbnail", file, file.previewUrl);
              //console.log(file.previewUrl);

              //file.previewElement.querySelector('.data-dz-thumbnail').setAttribute('src', file.previewUrl)

              file.previewElement.querySelector('.dz-preview-wrapper').classList.add('--no-preview')
              file.previewElement.querySelector('.dz-preview-extension').innerHTML = ext
              file.previewElement.querySelector('.data-dz-thumbnail').removeAttribute('data-dz-thumbnail')

              file.dataURL = file.previewUrl;
              myDropzone.createThumbnailFromUrl(file, myDropzone.options.thumbnailWidth, myDropzone.options.thumbnailHeight, myDropzone.options.resizeMethod, myDropzone.options.fixOrientation, function(thumbnail, canvas){
                //console.log('thumbnail custom')
                //console.log(file)
                file.previewElement.querySelector('.data-dz-thumbnail').setAttribute('src', thumbnail)
                //file.previewElement.querySelector('.data-dz-thumbnail').setAttribute('data-dz-thumbnail', '')
                file.previewElement.querySelector('.dz-preview-wrapper').classList.remove('--no-preview')
              });

            }
            else if( customPreviewExt.indexOf(ext) !== -1 && !file.previewUrl ) {
              const dzDetails = file.previewElement.querySelector('.dz-details')
              if( dzDetails ) {
                dzDetails.classList.add('dz-download-link')
              }

              file.previewElement.querySelector('.dz-preview-wrapper').classList.add('--no-preview')
              file.previewElement.querySelector('.dz-preview-extension').innerHTML = ext
              file.previewElement.querySelector('.data-dz-thumbnail').removeAttribute('data-dz-thumbnail')
            }
            else {
              file.previewElement.querySelector('.dz-preview-wrapper').classList.add('--no-preview')
              file.previewElement.querySelector('.dz-preview-extension').innerHTML = ext
              file.previewElement.querySelector('.data-dz-thumbnail').removeAttribute('data-dz-thumbnail')
            }
          }

          /*if( autoProcessQueue === false && file.status === 'added' &&  ext !== 'zip' ) {
            setTimeout(function () {
              //return myDropzone.processQueue();
            }, 100);
          }*/
        }
      )

      this.on('thumbnail',function(file, dataUrl) {
        //console.log('thumbnail')

        /*const ext = getExtension(file.name)
        if( ext === 'pdf' && file.previewUrl ) {
          //file.previewElement.querySelector('.data-dz-thumbnail').setAttribute('src', file.previewUrl)
          file.dataURL = file.previewUrl;
          myDropzone.createThumbnailFromUrl(file, myDropzone.options.thumbnailWidth, myDropzone.options.thumbnailHeight, myDropzone.options.resizeMethod, myDropzone.options.fixOrientation, function(thumbnail, canvas){
            console.log('thumbnail custom')
          });
        }*/

        /*var canvas = document.createElement("canvas");
        context = canvas.getContext('2d');

        make_base();

        function make_base()
        {
          base_image = new Image();
          base_image.src = 'img/base.png';
          base_image.onload = function(){
            context.drawImage(base_image, 100, 100);
          }
        }*/
        //var jpegUrl = canvas.toDataURL("image/jpeg");
        //var pngUrl = canvas.toDataURL(); // PNG is the default

        //file.previewElement.querySelector('.data-dz-thumbnail').setAttribute('src', file.previewUrl)

        //file.dataURL = file.previewUrl
        //myDropzone.createThumbnailFromUrl(file);

        //console.log(file.previewUrl)
        //console.log(dataUrl)
        // Display the image in your file.previewElement
      })

      this.on('sending',
        /**
         * @param {File} file
         * @param {XMLHttpRequest} xhr
         * @param {FormData} formData
         */
        function(file, xhr, formData){
          //console.log('dropzone sending')
          //console.log('type_upload', this.typeUpload)
          formData.append('order_id', orderId);
          formData.append('pxf_visibility', this.pxfVisibility);
          loadingWindowVisible('process', '#page-ajax')
        },
      )

      this.on('complete',
        /**
         * @param {File} file
         */
        function (file) {
          //console.log('dropzone complete')
          //console.log(file.status)

          if( autoProcessQueue === false ) {
            if( myDropzone.getQueuedFiles().length > 0 ) {
              myDropzone.processQueue()
            }
          }

          if( file.xhr ) {
            if( !file.existing ) {
              loadingWindowHidden('process', '#page-ajax')

              let response = JSON.parse(file.xhr.response)

              if( file.status == 'success' /*&& response.hasOwnProperty('file_id') && response['file_id']*/ ) {

                if( response.hasOwnProperty('files') ) {
                  //console.log('multi file')

                  //loadingWindowVisible('success', '#page-ajax')

                  response['files']['result'].forEach((file) => {

                    let previewUrl = ''
                    if( file.preview_src ) {
                      previewUrl = file.preview_src
                    }

                    this.displayExistingFile({
                      serverFileId: file.id,
                      name: file.name,
                      size: file.size,
                      createdAt: file.createdAt,
                      url: urlPrefix + file.url,
                      previewUrl: previewUrl,
                      existing: true
                    },
                      urlPrefix + file.url)
                  })

                  const dropzoneProjectElement = document.querySelector('.--project-files .order-detail__form-dropzone')
                  const dropzoneProject = Dropzone.forElement(dropzoneProjectElement);
                  const urlPrefixProject = window.location.origin + '/uploads/order_project_files/'
                  response['files']['project'].forEach((file) => {
                    let previewUrl = ''
                    if( file.preview_src ) {
                      previewUrl = file.preview_src
                    }

                    dropzoneProject.displayExistingFile({
                      serverFileId: file.id,
                      name: file.name,
                      size: file.size,
                      createdAt: file.createdAt,
                      url: urlPrefixProject + file.url,
                      previewUrl: previewUrl,
                      existing: true
                    }, urlPrefixProject + file.url)
                  })
                }
                else if( response.hasOwnProperty('file_id') && response['file_id'] ) {
                  //loadingWindowVisible('success', '#page-ajax')
                  //console.log('one file')

                  //let response = JSON.parse(file.xhr.responseText)
                  //console.log(response.preview_src)

                  const ext = getExtension(file.name)
                  if( customPreviewExt.indexOf(ext) !== -1 && response.preview_src ) {
                    file.dataURL = response.preview_src;
                    myDropzone.createThumbnailFromUrl(file, myDropzone.options.thumbnailWidth, myDropzone.options.thumbnailHeight, myDropzone.options.resizeMethod, myDropzone.options.fixOrientation, function(thumbnail, canvas){
                      //console.log('thumbnail custom')
                      file.previewElement.querySelector('.data-dz-thumbnail').setAttribute('src', thumbnail)
                      file.previewElement.querySelector('.dz-preview-wrapper').classList.remove('--no-preview')

                      const dzDetails = file.previewElement.querySelector('.dz-details')
                      dzDetails.classList.add('gallery-modal')
                      dzDetails.setAttribute('data-preview', response.preview_src)
                      dzDetails.classList.remove('dz-download-link')

                      runGallery()
                    });
                  }
                  else if( customPreviewExt.indexOf(ext) !== -1 && !response.preview_src ) {
                    const dzDetails = file.previewElement.querySelector('.dz-details')
                    if( dzDetails ) {
                      dzDetails.classList.add('dz-download-link')
                    }
                  }

                }
                else {
                  file.previewElement.remove()
                  loadingWindowVisible('error', '#page-ajax')

                  setErrorText()
                }
              }
              else {
                file.previewElement.remove()
                loadingWindowVisible('error', '#page-ajax')

                setErrorText()
              }
            }

            afterUploadToServer(this, file, orderFilesIdsElement)(file.xhr)

            runGallery()

          }
          else {

          }

        },
      )


      this.on('thumbnail', function(file, dataUrl) {
        //console.log(dataUrl)
      })

      this.on('removedfile',
        /**
         * @param {File} file
         */
        function (file) {
          removeFromServer(afterRemoveFromServer(this, file, orderFilesIdsElement), removeUrl)(file.serverFileId)

          runGallery()
        },
      )

      if (0 !== orderFilesIds.length && orderFiles) {
        orderFiles.forEach((file) => {
          let previewUrl = ''
          if( file.preview_name ) {
            previewUrl = urlPreviewPrefix + file.preview_name
          }

          this.displayExistingFile({
              serverFileId: file.id,
              name: file.name,
              size: file.size,
              createdAt: file.createdAt,
              url: urlPrefix + file.url,
              previewUrl: previewUrl,
              existing: true
            },
            urlPrefix + file.url
          )
        })
      }
    },
  })
}
